import * as React from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import SimpleCard from './SimpleCard'
import DashboardsPostagens from '../../../services/http/dashboards/DashboardsPostagens'
import { object } from 'prop-types'
import { mapFilterKeys } from '../../../utils/filterUtils'
export default function CardCategoriaMaisLida({ filters }) {
  const [postagem, setPostagem] = React.useState({
    obra_titulo: '',
    count_postagem_id: 0
  })

  const [loading, setLoading] = React.useState(true)

  async function getResumos(filters) {
    setLoading(true)

    const filterKeyMap = {
      biblioteca_id: 'leitor_biblioteca_id',
      funcao_id: 'leitor_funcao',
      departamento_id: 'leitor_departamento'
    }

    const filtroAdaptado = mapFilterKeys(filters, filterKeyMap)
    try {
      const { data } = await DashboardsPostagens().show({
        group_by: 'categoria_id,categoira_descricao,status_postagem_id',
        status_postagem_id: [1, 2],
        per_page: 1,
        count: 'postagem_id',
        'order_by[count_postagem_id]': 'desc',
        ...filtroAdaptado
      })
      setPostagem(
        data.data[0] || {
          leitor_nome: '',
          count_postagem_id: 0
        }
      )
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if (Object.keys(filters).length > 0) getResumos(filters)
  }, [filters])
  return (
    <Box>
      <Card variant="outlined">
        <SimpleCard
          title="Categoria mais lida"
          subtitle={postagem.categoira_descricao}
          footer={`Quantidade de Postagens: ${postagem.count_postagem_id?.toLocaleString(
            'pt-br'
          )}`}
          loading={loading}
        />
      </Card>
    </Box>
  )
}
CardCategoriaMaisLida.propTypes = {
  filters: object
}
